import { render } from "./ThongTinSoatVe.vue?vue&type=template&id=02a0485f"
import script from "./ThongTinSoatVe.vue?vue&type=script&lang=js"
export * from "./ThongTinSoatVe.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__